// Shared constants for the onboarding gate feature. Kept in a plain
// module (no React imports) so any consumer — including babel plugins
// that walk the import graph — can trace the source without pulling in
// React/Context runtime code.

export const ONBOARDING_LOCK_MESSAGE =
  'Please complete your profile, upload all required documents, ' +
  'and acknowledge all mandatory Company Policies and Terms & Conditions ' +
  'before accessing the rest of the application.';
